import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function SurveyRowActions({ survey, onActivate, onDeactivate, onDelete }) {
    const isActive = survey.status === 'ACTIVE';
    const canActivate = survey.status === 'DRAFT' || survey.status === 'CLOSED';

    return (
        <div className="surveys-actions">
            <Link
                to={`/surveys/${survey.id}/edit`}
                className="btn btn-sm btn-light-primary rounded-pill surveys-actions__btn"
                title="Edit survey"
            >
                <i className="bi bi-pencil me-1" aria-hidden="true" />
                Edit
            </Link>

            <Link
                to={`/surveys/${survey.id}/results`}
                className="btn btn-sm btn-outline-primary rounded-pill surveys-actions__btn"
                title="View survey responses"
            >
                <i className="bi bi-table me-1" aria-hidden="true" />
                Results
            </Link>

            {canActivate ? (
                <button
                    type="button"
                    className="btn btn-sm btn-outline-success rounded-pill surveys-actions__btn"
                    title="Activate survey"
                    onClick={() => onActivate(survey)}
                >
                    <i className="bi bi-play-fill me-1" aria-hidden="true" />
                    Activate
                </button>
            ) : null}

            {isActive ? (
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary rounded-pill surveys-actions__btn"
                    title="Deactivate survey"
                    onClick={() => onDeactivate(survey)}
                >
                    <i className="bi bi-pause-fill me-1" aria-hidden="true" />
                    Deactivate
                </button>
            ) : null}

            <Dropdown align="end" className="surveys-actions-dropdown">
                <Dropdown.Toggle
                    variant="light"
                    size="sm"
                    className="surveys-actions-dropdown__toggle"
                    title="More actions"
                >
                    <i className="bi bi-three-dots" aria-hidden="true" />
                </Dropdown.Toggle>

                <Dropdown.Menu className="surveys-actions-dropdown__menu" popperConfig={{ strategy: 'fixed' }}>
                    <Dropdown.Item
                        as={Link}
                        to={`/surveys/${survey.id}/graphs`}
                        className="surveys-actions-dropdown__item"
                    >
                        <i className="bi bi-bar-chart surveys-actions-dropdown__icon" aria-hidden="true" />
                        <span>View graphs</span>
                    </Dropdown.Item>

                    <div className="surveys-actions-dropdown__divider" role="separator" />

                    <Dropdown.Item
                        as="button"
                        type="button"
                        className="surveys-actions-dropdown__item surveys-actions-dropdown__item--danger"
                        onClick={() => onDelete(survey)}
                    >
                        <i className="bi bi-trash surveys-actions-dropdown__icon" aria-hidden="true" />
                        <span>Delete</span>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
}

export default SurveyRowActions;
